import scrollTo from 'popmotion-scroll-to';

const Intro = () => {
	const scrollComponent = document.querySelector(".scroll-down");
	const scrollToComponent = document.querySelector(".main-content");

	if (scrollComponent && scrollToComponent) {
		let positionDocument = window.scrollY;
		let positionTo = scrollToComponent.getBoundingClientRect();

		scrollComponent.addEventListener("click", () => {
			scrollTo(positionDocument + positionTo.top - 100);
		});
	}
};

export default Intro;
